// Merkan · Englisches Wörterbuch: Support-Anfragen an parlinex und Weitergabe aus Hugo
// Eigenständig formuliert, keine Wort-für-Wort-Übersetzung.
export default {
  'Support': 'Support',
  'Support: Anliegen an parlinex': 'Support: contact parlinex',
  'Anliegen an parlinex senden': 'Send a request to parlinex',
  'Anliegen an parlinex': 'Contact parlinex',
  'Beschreib kurz, worum es geht. Wir melden uns bei dir.': 'Tell us briefly what it is about. We will get back to you.',
  'Worum geht es?': 'What is it about?',
  'Frage zur Bedienung': 'How do I …',
  'Du weißt nicht, wie etwas geht': 'You are not sure how something works',
  'Etwas klappt nicht': 'Something is not working',
  'Fehlermeldung oder unerwartetes Verhalten': 'An error message or unexpected behaviour',
  'Idee oder Wunsch': 'Idea or request',
  'Was dir die Arbeit leichter machen würde': 'Something that would make your work easier',
  'Zum Beispiel: Sammelpostfach verbinden': 'For example: connect a shared mailbox',
  'Zum Beispiel: Rechnung wird nicht festgeschrieben': 'For example: invoice will not finalise',
  'Zum Beispiel: Vorgänge nach Hafen filtern': 'For example: filter cases by port',
  'Was möchtest du erreichen, und an welcher Stelle kommst du nicht weiter?': 'What are you trying to do, and where are you stuck?',
  'Was hast du gemacht, was ist passiert, und was hättest du erwartet? Eine Fehlermeldung gern wörtlich.': 'What did you do, what happened and what did you expect? Please copy any error message exactly.',
  'Was würde dir helfen, und in welcher Situation brauchst du das?': 'What would help, and in which situation would you use it?',
  'Beschreibung': 'Details',
  'Ein paar Worte genügen, damit wir die Anfrage zuordnen können.': 'A few words are enough for us to file your request.',
  'Ich kann gerade nicht weiterarbeiten': 'This is blocking my work',
  'Wir sehen dringende Anfragen zuerst an.': 'We look at urgent requests first.',
  'Seite und Gerät mitsenden': 'Include page and device',
  'Antwort an {email}': 'Reply to {email}',
  'Anfrage senden': 'Send request',
  'Wird gesendet …': 'Sending …',
  'Gesendet': 'Sent',
  'Senden (Strg und Enter)': 'Send (Ctrl and Enter)',
  'Senden (Cmd und Enter)': 'Send (Cmd and Enter)',
  'Schließen (Esc)': 'Close (Esc)',
  'Anfrage gesendet': 'Request sent',
  'Ist bei parlinex angekommen': 'parlinex has your request',
  'Deine Anfrage hat die Nummer': 'Your reference number is',
  'Nummer kopieren': 'Copy reference',
  'Nummer kopiert': 'Reference copied',
  'Die Antwort kommt per Mail an {email} oder in die Glocke.': 'You will get our reply by email to {email} or in the bell.',
  'Die Antwort kommt per Mail oder in die Glocke.': 'You will get our reply by email or in the bell.',
  'Gespräch mit {ki} mitsenden': 'Include the conversation with {ki}',
  'Die letzten Nachrichten, damit wir nicht noch einmal nachfragen müssen': 'The latest messages, so we do not have to ask again',
  'Bitte keine Passwörter oder Bankdaten eintragen.': 'Please do not enter passwords or bank details.',
  'Du hast sie als dringend markiert, wir sehen sie uns zuerst an.': 'You marked it as urgent, so it goes to the top of our list.',
  'Die Anfrage konnte nicht gesendet werden.': 'The request could not be sent.',
  'Die Anfrage konnte nicht gesendet werden. Bitte versuche es noch einmal oder schreib an support@parlinex.io.': 'The request could not be sent. Please try again or email support@parlinex.io.',
  'Keine Verbindung zum Server. Deine Eingaben bleiben erhalten, bitte gleich noch einmal senden.': 'No connection to the server. Nothing you typed is lost, please send again in a moment.',
  'Browser': 'Browser',
  '{browser} auf {system}, {breite}': '{browser} on {system}, {breite}',
  '{browser}, {breite}': '{browser}, {breite}',

  // Hinweis der Datenbank (Trigger trg_support_anfrage_nummer)
  'Du hast in der letzten Stunde schon viele Anfragen gesendet. Bitte versuche es etwas später erneut.': 'You have sent a lot of requests in the last hour. Please try again a little later.',

  // Weitergabe aus Hugo
  'An parlinex weitergeben': 'Pass on to parlinex',
  'Soll sich parlinex das ansehen?': 'Shall parlinex take a look?',
  'Ich gebe deine Frage an den Support weiter. Die Antwort kommt per Mail.': 'I will pass your question on to the support team. You will get the answer by email.',
  'Ich gebe deine {n} Fragen aus dieser Unterhaltung an den Support weiter. Die Antwort kommt per Mail.': 'I will pass your {n} questions from this conversation on to the support team. You will get the answer by email.',
  'Ich gebe deine beiden Fragen aus dieser Unterhaltung an den Support weiter. Die Antwort kommt per Mail.': 'I will pass both of your questions from this conversation on to the support team. You will get the answer by email.',
  'Weitergeben': 'Pass on',
  'Wird weitergegeben …': 'Passing on …',
  'Vorher ansehen': 'Review first',
  'Nein, danke': 'No, thanks',
  'Weitergegeben als': 'Passed on as',
  'Frage an {ki}': 'Question for {ki}',
  '{ki} hat auf diese Frage keine Antwort gefunden:': '{ki} could not find an answer to this question:',
  '{ki} hat auf diese Fragen keine Antwort gefunden:': '{ki} could not find answers to these questions:',
} satisfies Record<string, string>;
